import React, { useState, useEffect, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { AjouteAvisProduit } from '../Api/FinalReservationApi';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useDropzone } from 'react-dropzone';
import Logo from '../Image/logo.png';
import { toast } from 'react-toastify';
import '../Css/depotAvis2.css';

const DepotAvis2 = () => {

    const [selectImage, setSelectImage] = useState([]);
    const [errorImage, setErrorImage] = useState('');
    const [commentaireArriver, setCommentaireArriver] = useState('');
    const [commetaireRecommandier, setCommentaireRecommandier] = useState('');
    const [errorArriver, setErrorArriver] = useState('');
    const [errorRecommandier, setErrorRecommandier] = useState('');
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);


    let location = useLocation();
    let navigate = useNavigate();
    const { state } = useLocation();

    const { nomRestaurant, adresse, idRestaurant, idReservation, idClient, jour, heure, personne, idAvis } = state;

    const [avis, setAvis] = useState([
        {
            id: 1,
            name: "Réservation prise en compte ?",
            reponse: '',
            status: false
        },
        {
            id: 2,
            name: "Prise en compte de la réduction éventuelle lors de la réservation ?",
            reponse: '',
            status: false
        },
        {
            id: 3,
            name: "Prise en compte des spécificités mentionnées en commentaire lors de la réservation ?",
            reponse: '',
            status: false
        }
    ]);

    const [recommendez, setRecommandez] = useState([
        {
            id: 1,
            name: "Ce restaurant?",
            reponse: '',
            status: false
        },
        {
            id: 2,
            name: "L’utilisation de ce site ?",
            reponse: '',
            status: false
        }
    ]);

    const handleReponseArriver = (id, value) => {
        setAvis((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, reponse: value }
                } else {
                    return { ...item }
                }
            })
        })
    }



    const handleClose = () => setShow(false);



    const handleReponseRecommander = (id, value) => {
        setRecommandez((prev) => {
            return prev.map((item) => {
                if (item.id === id) {
                    return { ...item, reponse: value }
                } else {
                    return { ...item }
                }
            })
        })
    }


    // Dropzone
    const onDrop = useCallback((acceptedFiles, rejectFiles) => {

        acceptedFiles.forEach((file, index) => {

            if (file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png") {
                let fileSize = file.size / 1024 / 1024;
                if (fileSize > 1) {
                    setErrorImage('Taille max 1 MG');
                    const timer = setTimeout(() => setErrorImage(''), 4000);
                    return () => clearTimeout(timer);
                } else {
                    const reader = new FileReader();
                    reader.onload = () => {
                        setSelectImage(prevState => [...prevState, { id: index + 1, type: 'local', photo: "nouveau", base: "nouveau", file: reader.result }]);
                    }
                    reader.readAsDataURL(file);
                }

            } else {
                setErrorImage('Format image accepter PNG, JPEG, JPG');
                const timer = setTimeout(() => setErrorImage(''), 4000);
                return () => clearTimeout(timer);
            }

        });


        console.log('acceptedFiles', acceptedFiles);
        console.log('rejectFiles', rejectFiles);

    }, []);

    useEffect(() => {
        console.log(selectImage);
        console.log(selectImage.length);
    }, [selectImage])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: 'image/*',
    });

    console.log(getRootProps(), getInputProps());

    // Fin Dropzone


    // Drag and Drop
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    }

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const reorderedItems = reorder(selectImage, result.source.index, result.destination.index);

        console.log(reorder);

        setSelectImage(reorderedItems);

    }

    const grid = 8;
    const getListStyle = (isDraggingOver) => ({
        background: isDraggingOver ? 'lightblue' : 'white',
        display: 'flex',
        padding: grid,
        overflow: 'auto',
        marginTop: '10px'
    });

    const getItemStyle = (isDragging, draggableStyle) => ({
        userSelect: 'none',
        padding: grid * 2,
        margin: `0 ${grid}px 0 0`,
        background: isDragging ? 'white' : 'white',
        ...draggableStyle
    });

    // FIN Drag and Drop


    const formatPersonne = (personne) => {
        if (personne > 1) {
            return personne + " personnes";
        } else {
            return personne + " personne";
        }
    }

    const handleEnregistrer = () => {
        const arriver = avis.filter((el) => el.reponse !== "");
        const recommande = recommendez.filter((el) => el.reponse !== "");

        const autreArriver = avis.filter((el) => el.reponse === "Autre");
        const autreRecommande = recommendez.filter((el) => el.reponse === "Autre");

        if (autreArriver.length !== 0 && commentaireArriver === "") {
            setErrorArriver('Commentaire ne peut pas être null');
            const timer = setTimeout(() => setErrorArriver(''), 3000);
            return () => clearTimeout(timer);
        } else if (autreRecommande.length !== 0 && commetaireRecommandier === "") {
            setErrorRecommandier('Commentaire ne peut pas être null');
            const timer = setTimeout(() => setErrorRecommandier(''), 3000);
            return () => clearTimeout(timer);
        } else {
            setLoading(true);
            const data = { photos: selectImage, commentaireArriver: commentaireArriver, commentaireRecommande: commetaireRecommandier, avisArriver: arriver, avisRecommender: recommande, idRestaurant: idRestaurant, idClient: idClient, idAvis: idAvis };
            AjouteAvisProduit(data).then(function (response) {
                console.log(response);
                if (response.data.title === "success") {
                    toast.success("Merci pour votre avis");
                    setCommentaireArriver('');
                    setCommentaireRecommandier('');
                    selectImage([]);
                    setShow(true);
                    navigate('/');

                }
            }).catch(function (error) {
                console.log(error);
                if (error) {
                    console.log(error.response?.data.message);
                }

            }).finally(function () {
                setLoading(false);
                navigate('/');
            });

        }
    }

    const handleFermer = () => {
        setShow(true);
        navigate('/');
    }

    return (
        <div>
            <Helmet>
                <title>Depot avis produit</title>
                <meta name='description' content='Depot avis produit' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='avis_produit'>
                <div className='avis_produitContent'>
                    <div className='deposAvisLogo'>
                        <img src={Logo} alt="logo restaurant" width="100px" />
                    </div>

                    <div className='avis1_header'>
                        <div className='apropos'>
                            <h1>Avis sur le Produit / service  :</h1>
                            <h2>{nomRestaurant}</h2>
                            <h2>Adresse {adresse}</h2>
                            <span>Réservation du {jour} à {heure} pour {formatPersonne(personne)}</span>
                            <div><span>N° de séservation {idReservation}</span></div>
                        </div>
                    </div>
                    <div className='avis_produitBody'>
                        <div className='item_arriver'>
                            <h3>A votre arrivée :</h3>
                            {avis.map((item, index) => {
                                return (
                                    <div className='avis2_item' key={index}>
                                        <h4>{item.name}</h4>
                                        <div className='item_qualiter'>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name={item.name + "inlineRadioOptions"} onChange={() => handleReponseArriver(item.id, "Oui")} id={item.name + "inlineRadio1"} defaultValue={item.name + "optionTresOui"} />
                                                <label className="form-check-label" htmlFor={item.name + "inlineRadio1"} >Oui</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name={item.name + "inlineRadioOptions"} onChange={() => handleReponseArriver(item.id, "Non")} id={item.name + "inlineRadio2"} defaultValue={item.name + "optionTresNon"} />
                                                <label className="form-check-label" htmlFor={item.name + "inlineRadio2"} >Non</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name={item.name + "inlineRadioOptions"} onChange={() => handleReponseArriver(item.id, "Autre")} id={item.name + "inlineRadio3"} defaultValue={item.name + "optionAutre"} />
                                                <label className="form-check-label" htmlFor={item.name + "inlineRadio3"} >Autre</label>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                            <div className='commentaire_arriver mt-2'>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlTextarea1" className="form-label">Commentaire</label>
                                    <textarea className="form-control" value={commentaireArriver} onChange={(e) => setCommentaireArriver(e.target.value)} id="exampleFormControlTextarea1" rows={3} placeholder="Commentaire ..." />
                                </div>
                                {errorArriver !== "" ? <span className="errorValue">{errorArriver}</span> : ''}
                            </div>
                        </div>

                        <div className='item_recommande mt-4'>
                            <h3>Recommanderiez-vous :</h3>
                            {recommendez.map((item, index) => {
                                return (
                                    <div className='avis2_item' key={index}>
                                        <h4>{item.name}</h4>
                                        <div className='item_qualiter'>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name={item.name + "inlineRadioOptions"} onChange={() => handleReponseRecommander(item.id, "Oui")} id={item.name + "inlineRadio1"} defaultValue={item.name + "optionTresOui"} />
                                                <label className="form-check-label" htmlFor={item.name + "inlineRadio1"} >Oui</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name={item.name + "inlineRadioOptions"} onChange={() => handleReponseRecommander(item.id, "Non")} id={item.name + "inlineRadio2"} defaultValue={item.name + "optionTresNon"} />
                                                <label className="form-check-label" htmlFor={item.name + "inlineRadio2"} >Non</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name={item.name + "inlineRadioOptions"} onChange={() => handleReponseRecommander(item.id, "Autre")} id={item.name + "inlineRadio3"} defaultValue={item.name + "optionAutre"} />
                                                <label className="form-check-label" htmlFor={item.name + "inlineRadio3"} >Autre</label>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                            <div className='commentaire_recommander mt2'>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlTextarea1" className="form-label">Commentaire</label>
                                    <textarea className="form-control" id="exampleFormControlTextarea1" value={commetaireRecommandier} onChange={(e) => setCommentaireRecommandier(e.target.value)} rows={3} placeholder="Commentaire ..." />
                                </div>
                                {errorRecommandier !== "" ? <span className="errorValue">{errorRecommandier}</span> : ''}
                            </div>
                        </div>
                        <div className='avis_photos'>
                            <h3>Télécharger vos photos:</h3>
                            <p>Ils apparaîtront sur la fiche du restaurant – après vérification par le modérateur. Photos des plats uniquement, ou du cadre, sans la présence de personne identifiable dessus</p>

                            <div className='d-flex justify-content-center'>
                                <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
                                    <div className='input_photo'>
                                        <div className='dropzone' {...getRootProps()}>
                                            <div className='image_appareil'>
                                                <input {...getInputProps()} />
                                                <label htmlFor="fileInput" className="d-flex justify-content-center" id="fileLabel">
                                                    {isDragActive ? <div className='avatar d-flex justify-content-center align-items-center'>
                                                        <i className='fa fa-cloud-download'></i>
                                                    </div> : <div className='avatar d-flex justify-content-center align-items-center'>
                                                        <i className='fa fa-picture-o'></i>
                                                    </div>}
                                                </label>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <p>Format accepter : png/jpeg/jpg , taille max 1 MG</p>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            {errorImage !== "" ? <span className="errorValue">{errorImage}</span> : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <DragDropContext onDragEnd={onDragEnd}>
                                    <Droppable droppableId="droppable" direction="horizontal">
                                        {(provided, snapshot) => (
                                            <div className="droppable" {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
                                                {selectImage.map((file, index) => {
                                                    return (
                                                        <Draggable className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3' Draggable key={file.file} draggableId={file.file} index={index}>
                                                            {(provided, snapshot) => (
                                                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                                                    style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                                                                    <div className='liste_image'>
                                                                        <div className='image_item'>
                                                                            <img src={file.file} alt="produit restaurant" title='produit restaurant' />
                                                                        </div>
                                                                        <div className='d-flex justify-content-end'>
                                                                            <i className='fa fa-close' onClick={() => setSelectImage(selectImage.filter((el) => el.file !== file.file))}></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    );

                                                })}
                                            </div>
                                        )}

                                    </Droppable>
                                </DragDropContext>
                            </div>
                        </div>
                        <div className='avis_produit_add'>
                            <div className='d-flex justify-content-center'>
                                {loading ? <Button className='btn btn_ajouteAvisProduit' disabled>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        variant="info"
                                        className="spiner"
                                    />
                                    Loading...
                                </Button> : <button className='btn' onClick={handleEnregistrer}>Enregistrer</button>}

                            </div>
                        </div>
                        <Modal show={show} onHide={handleClose}>
                            <Modal.Body>
                                <div className='modal_avis'>
                                    <p>« Nous vous remercions de vos retours et à la prochaine pour le même restaurant … et/ou pleins d’autres ! ;-) »</p>
                                    <div className='d-flex justify-content-center'>
                                        <button className='btn btn_fermer' onClick={handleFermer}>Fermer</button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                        <p className="version">Version 1</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DepotAvis2